module.exports = __webpack_public_path__ + "media/categories/21v-ecf63a50.svg";